import DataAdapter from 'rise-ui/adapters/apis/rise-api/data.js';

export default class ItemAdapter extends DataAdapter {
  pathForType() {
    return 'catalog-item';
  }
}
